module.exports = __webpack_public_path__ + "static/media/hero-bg.cfbb818a.jpg";